import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { PhoneInput } from 'react-international-phone';
import 'react-international-phone/style.css';
import useInView from '../../hooks/useInView';
import styles from './ContactForm.module.css';

const API_URL = '';

export default function ContactForm({ type = 'consultation' }) {
  const isCalc = type === 'calculation';
  const [form, setForm] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    ...(isCalc ? { product: '', country: '', volume: '' } : {})
  });
  const [agreed, setAgreed] = useState(false);
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!agreed) {
      setStatus({ type: 'error', text: 'Необходимо согласие на обработку персональных данных' });
      return;
    }
    setLoading(true);
    setStatus(null);
    try {
      const res = await fetch(`${API_URL}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, formType: type })
      });
      const data = await res.json();
      if (res.ok) {
        setStatus({ type: 'success', text: 'Заявка отправлена! Мы свяжемся с вами в ближайшее время.' });
        setForm({ name: '', email: '', phone: '', message: '', product: '', country: '', volume: '' });
        setAgreed(false);
      } else {
        setStatus({ type: 'error', text: data.error || 'Ошибка отправки. Попробуйте позже.' });
      }
    } catch (err) {
      console.error('Form submission error:', err);
      setStatus({ type: 'error', text: 'Ошибка сети. Попробуйте позже.' });
    }
    setLoading(false);
  };

  const [sectionRef, isVisible] = useInView();

  return (
    <section className={`${styles.section} ${isCalc ? styles.sectionCalc : ''} ${isVisible ? styles.visible : ''}`} id={isCalc ? 'calculation' : 'contact-form'} ref={sectionRef}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.info}>
            <span className={styles.badge}>{isCalc ? 'Расчёт' : 'Консультация'}</span>
            <h2 className={styles.title}>
              {isCalc ? 'Заявка на расчёт' : 'Получить консультацию'}
            </h2>
            <p className={styles.text}>
              {isCalc
                ? 'Оставьте заявку, и мы рассчитаем стоимость импорта или экспорта вашей продукции. Мы подготовим индивидуальное коммерческое предложение.'
                : 'Оставьте заявку, и наши специалисты свяжутся с вами для бесплатной первичной консультации по вопросам ВЭД.'
              }
            </p>
            <div className={styles.contactItems}>
              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>✉</span>
                <div>
                  <div className={styles.contactLabel}>Email</div>
                  <a href="mailto:info@konsultant-sovetnik.ru" className={styles.contactValue}>info@konsultant-sovetnik.ru</a>
                </div>
              </div>
              <div className={styles.contactItem}>
                <span className={styles.contactIcon}>📞</span>
                <div>
                  <div className={styles.contactLabel}>Телефон</div>
                  <a href="tel:+79109369889" className={styles.contactValue}>+7 (910) 936-98-89</a>
                </div>
              </div>
            </div>
          </div>

          <form className={styles.form} onSubmit={handleSubmit}>
            <div className={styles.row}>
              <div className={styles.field}>
                <label className={styles.label}>Имя *</label>
                <input
                  className={styles.input}
                  type="text"
                  name="name"
                  value={form.name}
                  onChange={handleChange}
                  placeholder="Ваше имя"
                  required
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Телефон *</label>
                <PhoneInput
                  defaultCountry="ru"
                  value={form.phone}
                  onChange={(phone) => setForm({ ...form, phone })}
                  inputClassName={styles.phoneInput}
                  countrySelectorStyleProps={{
                    buttonClassName: styles.phoneCountryBtn,
                  }}
                  placeholder="+7 (___) ___-__-__"
                />
              </div>
            </div>

            <div className={styles.field}>
              <label className={styles.label}>Email</label>
              <input
                className={styles.input}
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="example@mail.ru"
              />
            </div>

            {isCalc && (
              <>
                <div className={styles.row}>
                  <div className={styles.field}>
                    <label className={styles.label}>Наименование товара</label>
                    <input
                      className={styles.input}
                      type="text"
                      name="product"
                      value={form.product}
                      onChange={handleChange}
                      placeholder="Например: оборудование, мебель"
                    />
                  </div>
                  <div className={styles.field}>
                    <label className={styles.label}>Страна</label>
                    <input
                      className={styles.input}
                      type="text"
                      name="country"
                      value={form.country}
                      onChange={handleChange}
                      placeholder="Турция, Китай, Германия..."
                    />
                  </div>
                </div>
                <div className={styles.field}>
                  <label className={styles.label}>Объём / вес</label>
                  <input
                    className={styles.input}
                    type="text"
                    name="volume"
                    value={form.volume}
                    onChange={handleChange}
                    placeholder="Ориентировочный объём партии"
                  />
                </div>
              </>
            )}

            <div className={styles.field}>
              <label className={styles.label}>Сообщение</label>
              <textarea
                className={styles.textarea}
                name="message"
                value={form.message}
                onChange={handleChange}
                placeholder={isCalc ? 'Опишите вашу задачу подробнее' : 'Ваш вопрос или комментарий'}
                rows={4}
              />
            </div>

            <label className={styles.checkbox}>
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
              />
              <span className={styles.checkmark}></span>
              <span className={styles.checkboxText}>
                Я согласен на обработку{' '}
                <Link to="/privacy" target="_blank">персональных данных</Link>
              </span>
            </label>

            {status && (
              <div className={`${styles.status} ${styles[status.type]}`}>
                {status.text}
              </div>
            )}

            <button
              type="submit"
              className={styles.submit}
              disabled={loading}
            >
              {loading ? 'Отправка...' : (isCalc ? 'Запросить расчёт' : 'Отправить заявку')}
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}
